import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { InvestorViewerOverview } from '../../../../../../core/models/api.models';
import { formatAtlasGerePar } from '../../../../shared/atlas-inspection.utils';
import {
  formatBoolean,
  formatDate,
  formatInvestorLink,
  formatNotes,
  formatNumber,
  formatText
} from '../../investor-viewer-format.utils';
import { InvestorViewerAccordionComponent } from '../investor-viewer-accordion/investor-viewer-accordion.component';

@Component({
  selector: 'dbw-investor-viewer-overview-section',
  imports: [InvestorViewerAccordionComponent],
  templateUrl: './investor-viewer-overview-section.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: '../../investor-viewer-section.shared.scss'
})
export class InvestorViewerOverviewSectionComponent {
  readonly viewer = input.required<InvestorViewerOverview>();
  readonly gerePar = input<number | null | undefined>(undefined);

  protected readonly formatGerePar = formatAtlasGerePar;
  protected readonly formatText = formatText;
  protected readonly formatNumber = formatNumber;
  protected readonly formatBoolean = formatBoolean;
  protected readonly formatDate = formatDate;
  protected readonly formatNotes = formatNotes;
  protected readonly formatInvestorLink = formatInvestorLink;
}
